// Fetches rendered data for a single report chart. Unlike use-charts.js, filters are
// derived server-side from the chart's linked View, so only pagination/sort params are sent.
import { useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import { apiGet, apiPostQuery, estimateQueryStringLength } from 'api'
import AuthContext from 'context/auth-context'

// Puma's default query string limit is 10KB; use POST well before that.
const MAX_GET_QUERY_LENGTH = 8000

const getReportChartData = async (token, chartId, params) => {
  if (estimateQueryStringLength(params) > MAX_GET_QUERY_LENGTH) {
    return apiPostQuery({ url: `report_charts/${chartId}/data/query`, token, params })
  }

  const url = `report_charts/${chartId}/data`
  const data = await apiGet({ url, token, params })
  return data
}

export default function useReportChartData({ reportId, chartId, params, options }) {
  const token = useContext(AuthContext)

  // report_id (which report is on screen — a child renders its parent's charts) arrives in
  // `params` via REPORT_CHART_ADAPTER.dataRequestParams, so that one definition also covers the
  // pivot/data-table requests that never come through this hook.
  const stableParamsKey = useMemo(() => JSON.stringify(params || {}), [params])

  const queryKey = ['report-chart-data', reportId, chartId, stableParamsKey]
  const queryFn = () => getReportChartData(token, chartId, params)

  return useQuery(queryKey, queryFn, { ...options })
}
